import { render, staticRenderFns } from "./topic_item_dialog.vue?vue&type=template&id=a3c7c0ca"
import script from "./topic_item_dialog.vue?vue&type=script&lang=js"
export * from "./topic_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./topic_item_dialog.vue?vue&type=style&index=0&id=a3c7c0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports